import { FormattedMessage } from "react-intl";

// Tüm widget'ların altında görünen "Provided by Kapital Events" rozeti
const PoweredBy = () => (
	<footer className="powered-by">
		<a
			className="powered-by__link"
			href="https://kapital.com.tr/"
			target="_blank"
			rel="noopener noreferrer"
		>
			<span className="powered-by__text">
				<FormattedMessage id="brand-description" />
			</span>
			<img
				className="powered-by__logo"
				src="https://kapital-events.s3.eu-central-1.amazonaws.com/assets/logo/event-logo-notification.png"
				alt="Kapital Media Group"
			/>
		</a>
	</footer>
);

export default PoweredBy;
